/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_SymbolInputs */

const en_reference_field_symbol = /** @type {(inputs: Reference_Field_SymbolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Symbol`)
};

/**
* | output |
* | --- |
* | "Symbol" |
*
* @param {Reference_Field_SymbolInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_symbol = /** @type {((inputs?: Reference_Field_SymbolInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_SymbolInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_symbol(inputs)
});